import { render, staticRenderFns } from "./parent-importer-page.vue?vue&type=template&id=6ca2ff4d&"
import script from "./parent-importer-page.vue?vue&type=script&lang=js&"
export * from "./parent-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports